import { inject, Injectable, signal } from '@angular/core';
import { WindowService } from '@nx-customer-apps/shared/services';
import { ProjectResponseGetById } from '@nx-customer-apps/api-planning-projects';
import { HeatLoadCalculationMethod } from '@nx-customer-apps/components';
import { SWITCH_TO_ROOM_BASED_HEAT_LOAD_DIALOG_LOCAL_STORAGE_KEY } from '../../../utils';

@Injectable({
    providedIn: 'root'
})
export class CalculationMethodService {
    private windowService = inject(WindowService);
    private _hideSwitchToRoomBasedHeatLoadDialog = signal(false);

    public get hideSwitchToRoomBasedHeatLoadDialog(): boolean {
        return this._hideSwitchToRoomBasedHeatLoadDialog();
    }

    public set hideSwitchToRoomBasedHeatLoadDialog(value: boolean) {
        this._hideSwitchToRoomBasedHeatLoadDialog.set(value);
    }

    public saveSwitchToRoomBasedHeatLoadDialogVisibility(): void {
        if (this.hideSwitchToRoomBasedHeatLoadDialog) {
            this.windowService.localStorage.setItem(SWITCH_TO_ROOM_BASED_HEAT_LOAD_DIALOG_LOCAL_STORAGE_KEY, 'true');
        }
    }

    public canShowSwitchToRoomBasedHeatLoadDialog(isEditRoomPlan: boolean, project: ProjectResponseGetById | undefined): boolean {
        const isDialogHidden = this.windowService.localStorage.getItem(SWITCH_TO_ROOM_BASED_HEAT_LOAD_DIALOG_LOCAL_STORAGE_KEY) === 'true';
        return isEditRoomPlan && this.isNotRoomByRoomCalculationSelectionPrefilled(project) && !isDialogHidden;
    }

    public isNotRoomByRoomCalculationSelectionPrefilled(project: ProjectResponseGetById | undefined): boolean {
        const selectedCalculation = project?.building?.heatLoadCalculations?.find(calculation => calculation.isSelected);
        return selectedCalculation !== undefined && selectedCalculation.method !== HeatLoadCalculationMethod.RoomByRoom;
    }
}
